import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { SystemStatusProvider } from './contexts/SystemStatusContext';
import { initHaptics } from './utils/haptics';
import { initPlatform, configureKeyboard, configureStatusBar } from './platform/capacitor';
import './hooks/useResponsive';
import './styles/global.css';
import './styles/responsive.css';

initHaptics().catch(() => { /* fallback web silencieux */ });
initPlatform()
  .then(() => Promise.all([configureKeyboard(), configureStatusBar()]))
  .catch(() => { /* pas de Capacitor en mode web */ });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <SystemStatusProvider>
        <App />
      </SystemStatusProvider>
    </BrowserRouter>
  </StrictMode>
);
